export class Allegato {
    public uuid: string;
    public name: string;
    public original_name: string;
    public path: string;
    public mimetype: string;
    public table_name: string;
    public table_key: string;
    public size: number;
    public tipo_allegato: string;
    constructor() {
    }
}